import React, { useMemo, useState } from 'react';
import style from './index.module.css';
import mail from '../../../Assets/mail.svg';
import PasswordIcon from '../../../Assets/PasswordIcon.svg';
import edit from '../../../Assets/edit.svg';
import * as api from '../../../services/api';
import studentlogo from '../../../Assets/studentlogo.svg';

import eye from '../../../Assets/eye.svg';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/actions';
import { Link, useNavigate } from 'react-router-dom';

import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from '@chakra-ui/alert';
import Swal from 'sweetalert2';
import FirstForm from './FirstForm';
import SecondForm from './SecondForm';
import { Loader } from '../../../Components/Loader/Loader';
import Password from './Password';

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [input, setInput] = useState({
    firstName: '',
    lastName: '',
    email: '',
    createPassword: '',
    password: '',
    file: '',
    walletId: '',
    phone: '',
    jobTitle: '',
  });
  const [formData, setFormData] = useState([]);
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInput({ ...input, [name]: value });
  };
  // console.log('input', input);

  const [loading, setLoading] = useState(false);

  const FormTitle = ['1', '2', '3'];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (page === FormTitle.length - 1) {
      if (
        input.email &&
        input.createPassword &&
        input.firstName &&
        input.password === input.createPassword &&
        input.file
      ) {
        // let newdata = { ...input, id: new Date().getTime().toString() };
        // setFormData([...formData, newdata]);
        const uploadData = new FormData();
        uploadData.append('file', input.file);
        uploadData.append('name', `${input.firstName} ${input.lastName}`);
        uploadData.append('email', input.email);
        uploadData.append('jobTitle', input.jobTitle);
        uploadData.append('password', input.createPassword);
        uploadData.append('walletId', input.walletId);
        uploadData.append('profile', 'ajna_student');
        uploadData.append('phone', input.phone);
        setLoading(true);
        api
          .signup(uploadData)
          .then((res) => {
            // console.log('res', res.status);

            if (res.status === 201) {
              // Swal.fire('Your Account created successfully');
              Swal.fire({
                icon: 'success',
                text: 'Your Account created successfully',
                timer: 1300,
              });
            }

            const user = res.data.user;

            dispatch(
              authActions.login({
                email: user?.email,
                password: input.createPassword,
                profile: 'ajna_student',
              })
            );
            setLoading(false);
            navigate('/hiring/student/findjob');
          })
          .catch((err) => {
            setLoading(false);
            // console.log('errororooroepro', err);
            if (err.response.data.message === 'User already exists') {
              Swal.fire('User Already Exist');
              Swal.fire({
                icon: 'error',
                text: 'User Already Exist',
                timer: 1300,
              });
            }
            if (err.response.status === 500) {
              // Swal.fire('Internal Server Error');
              Swal.fire({
                icon: 'error',
                text: 'OOPS! Something went wrong',
                timer: 1300,
              });
            }
          });
      } else if (input.file === '') {
        Swal.fire({
          icon: 'warning',
          text: 'Please Upload Image',
          timer: 1300,
        });
      } else {
        Swal.fire({
          icon: 'warning',
          text: 'Please fill data!',
          timer: 1300,
        });
      }
    }
  };

  const changeImage = (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];
    const fileSize = selectedFile.size;
    const fileSizeMb = fileSize / 1024 ** 2;

    if (fileSizeMb < 5) {
      const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
      // console.log(selectedFile);
      if (!allowedExtensions.exec(selectedFile?.name)) {
        Swal.fire({
          icon: 'warning',
          text: 'Please upload jpg/jpeg/png file...',
          timer: 1300,
        });
        return;
      }
      setInput((state) => ({
        ...state,
        file: e.target.files[0],
      }));
    } else {
      Swal.fire({
        icon: 'warning',
        text: 'File size should be less than 5MB',
        timer: 1300,
      });
    }
  };

  const validateAndNext = (e) => {
    e.preventDefault();
    var emailreg =
      /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!emailreg.test(input.email)) {
      Swal.fire({
        icon: 'warning',
        text: 'Please enter valid email address!',
        timer: 2000,
      });
      return;
    }
    setPage(1);
  };

  const validatePassword = (e) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
    if (input.password === '' || input.confirmpassword === '') {
      Swal.fire({
        icon: 'warning',
        text: 'Please enter password!',
        timer: 2000,
      });
      return;
    } else if (input.password !== input.createPassword) {
      Swal.fire({
        icon: 'warning',
        text: 'Passwords do not match!',
        timer: 2000,
      });
      return;
    } else {
      setPage(2);
    }
    return;
  };

  return (
    <>
      {!loading ? (
        <div className={style.container}>
          <div className={style.namaskaram}>
            <img src={studentlogo} alt='studentlogo' />
          </div>
          <div className={style.namaskaram}>Create your account!</div>
          <div className={style.welcome}>Lets Create Your Account</div>
          <form className={style.formContainer}>
            {page === 0 && (
              <FirstForm handleChange={handleChange} input={input} />
            )}

            {page === 1 && (
              <Password handleChange={handleChange} input={input} />
            )}
            {page === 2 && (
              <SecondForm changeImage={changeImage} input={input} />
            )}
            {page === 0 && (
              <div className={style.btncont}>
                <button
                  className={style.BackBtn}
                  onClick={() => navigate(-1, { replace: true })}
                  type='button'
                >
                  Back
                </button>

                <button
                  onClick={(e) =>
                    !input.firstName ||
                    !input.email ||
                    input.createPassword !== input.password
                      ? null
                      : validateAndNext(e)
                  }
                  className={style.nextBtn}
                  disabled={
                    !input.firstName ||
                    !input.email ||
                    input.createPassword !== input.password
                  }
                  style={{
                    cursor:
                      !input.firstName ||
                      !input.email ||
                      input.createPassword !== input.password
                        ? 'not-allowed'
                        : 'pointer',
                  }}
                >
                  Next
                </button>
              </div>
            )}
            {page === 1 && (
              <div className={style.btncont}>
                <button
                  className={style.BackBtn}
                  onClick={() => setPage(0)}
                  type='button'
                >
                  Back
                </button>
                <div
                  className={style.nextBtn}
                  onClick={(e) => validatePassword(e)}
                >
                  <button style={{ cursor: 'pointer' }} type='button'>
                    Next
                  </button>
                </div>
              </div>
            )}

            {page === 2 && (
              <div className={style.btncont}>
                <button
                  className={style.BackBtn}
                  onClick={() => setPage(1)}
                  type='button'
                >
                  Back
                </button>
                <div className={style.nextBtn} onClick={handleSubmit}>
                  <button style={{ cursor: 'pointer' }} type='button'>
                    Next
                  </button>
                </div>
              </div>
            )}
          </form>
          <div className={style.already}>
            <div>Already a member?</div>
            <div style={{ textDecoration: 'underline', fontWeight: '600' }}>
              {' '}
              <Link to='/'> Login</Link>{' '}
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default Register;
